// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Fragment } from 'react';
import { Chip } from '@mui/material';
import { Claim } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import PartyDisplay from '../../components/PartyDisplay';

interface ClaimsProps {
  claims: Claim[];
}

const Claims: React.FC<ClaimsProps> = ({ claims }) => {
  return (
    <>
      {claims.map((claim, index) => (
        <Fragment key={claim.property + claim.value}>
          {claim.subject.includes('::') ? (
            // TODO: How can we better recognize party IDs?
            <Chip label={<PartyDisplay party={claim.subject} />} />
          ) : (
            <Chip label={claim.subject} />
          )}
          <Chip label={claim.property} />
          <Chip label={claim.value} />
          {index < claims.length - 1 && ' ∧ '}
        </Fragment>
      ))}
    </>
  );
};

export default Claims;
